import {injectGlobal} from 'styled-components'
import VAG from '../assets/fonts/VAG-HandWritten.otf'
import CaviarDreams from '../assets/fonts/CaviarDreams.ttf'
import theme from './theme'

injectGlobal`
@font-face {
  font-family: 'VAG';
  font-display: block;
  src: url(${VAG}) format('opentype');
}
@font-face {
  font-family: 'CaviarDreams';
  font-display: fallback;
  src: url(${CaviarDreams}) format('truetype');
}

*, :after, :before {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  line-height: 1.15;
  font-size: 15px;
  font-family: ${theme.bodyFontFamily};
}

h3 {
  font-weight: normal;
}

h4 {
  font-weight: bold;
}

textarea {
  font-family: inherit;
}

.ajax-spinner {
  width: 40px;
  height: 40px;
  background-color: white;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
  font-size: 0;
  position: fixed;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  z-index:10;
}
.ajax-error {
  color: white;
  background-color: brown;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  position: fixed;
  top: calc(50% - 20px);
  left: 20px;
  right: 20px;
  z-index: 10;
}

.ui.modal {
  position: relative!important;
  margin: auto!important;
  img {
    max-height: 250px !important;
    height: 100% !important;
    object-fit: cover !important;
  }
  & > .header:not(.ui) {
    font-family: ${theme.headFontFamily};
  }
  .ui.header {
    font-size: 1.2rem;
  }
}
`



// WEBPACK FOOTER //
// ./src/style/global.js